<script setup>
import { computed } from 'vue';
import { ref } from 'vue';

const props = defineProps({
    items: {
        type: Array,
        required: true
    },
    icon: {
        type: String,
        required: true
    },
    iconColor: {
        type: String,
        required: false,
        default: null
    },
    cols: {
        type: Number,
        required: false,
        default: 1
    },
    type: {
        type: String,
        required: false,
        default: 'default'
    }
});

const colors = ref([
    {
        type: 'warning',
        icon: 'text-amber-500',
        bg: 'bg-amber-50',
        border: 'border-amber-200 border'
    },
    {
        type: 'success',
        icon: 'text-green-500',
        bg: 'bg-green-50',
        border: 'border-green-200 border'
    },
    {
        type: 'info',
        icon: 'text-blue-500',
        bg: 'bg-indigo-50',
        border: 'border-blue-200 border'
    },
    {
        type: 'danger',
        icon: 'text-red-500',
        bg: 'bg-red-50',
        border: 'border-red-200 border'
    },
    {
        type: 'default',
        icon: 'text-gray-500',
        bg: 'bg-white',
        border: ''
    }
]);

const setColors = computed(() => {
    const color = colors.value.find(color => color.type === props.type);

    if(props.iconColor) {
        color.icon = props.iconColor;
    } else {
        color.icon = 'text-gray-500';
    }

    return color;
});

const showAllTips = ref(false);

</script>

<template>
    <ul class="space-y-3">
        <TransitionGroup
            name="fade"
            tag="div"
            :style="{
                gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
                gap: '0.75rem'
            }"
            class="space-y-2 grid-container md:grid md:space-y-0"
        >
            <li v-for="(item, index) in items.slice(0, showAllTips || items.length <= 6 ? items.length : 6)" :key="index"
                class="flex p-3 overflow-hidden rounded-md md:items-center" :class="setColors.bg + ' ' + setColors.border">
                <i class="flex items-center justify-center flex-shrink-0 w-5 h-5 mt-1 mr-3 text-lg md:mr-4 fa-regular md:mt-0" :class="'fa-'+icon + ' ' + setColors.icon"></i>
                <span class="text-gray-700" v-if="!item.startsWith('**')">{{ item.split('[')[0] }}</span>
                <span class="text-gray-700" v-else v-html="item.replace('**', '<b>').replace('**', '</b>').split('[')[0]"></span>
            </li>
        </TransitionGroup>
    </ul>
    <Transition name="fade">
        <div class="flex justify-end mt-4">
            <button-secondary
                v-if="items.length > 6"
                @click="showAllTips = !showAllTips"
            >
                {{ showAllTips ? 'Show Less' : `Show All (${items.length - 6} more)` }}
            </button-secondary>
        </div>
    </Transition>
</template>
